import React from 'react';
import { CornerDownRight } from 'lucide-react';
import { abrirSolicitacao } from '../../src/lib/abrirSolicitacao';

// Marca de subtarefa na Central de Solicitações: "↳ Subtarefa de #6208 · título da mãe".
// Clicar abre a solicitação mãe por cima da tela (sem navegar). Mesmo roxo da faixa
// lateral do card (SUBTAREFA_FAIXA), para as duas marcas se lerem como uma só.

/** Faixa lateral do card/linha de subtarefa. */
export const SUBTAREFA_FAIXA = 'border-l-4 border-l-violet-400 dark:border-l-violet-500';

interface Props {
    parentId: string | number;
    tituloMae?: string | null;
    /** Logo abaixo da mãe (Lista/Tabela agrupadas): não repete o título dela. */
    compacto?: boolean;
    className?: string;
    /** Sobrescreve o destino do clique (Tarefa comum abre a mãe no painel de Tarefas, não o modal de Solicitação). */
    onAbrir?: () => void;
}

const SeloSubtarefa: React.FC<Props> = ({ parentId, tituloMae, compacto, className = '', onAbrir }) => (
    <button
        type="button"
        // stopPropagation: o clique no card abriria a própria subtarefa por baixo.
        // (Arrastar a partir do selo o @hello-pangea/dnd já bloqueia por ser um botão.)
        onClick={(e) => { e.stopPropagation(); if (onAbrir) onAbrir(); else abrirSolicitacao(String(parentId)); }}
        title={`Subtarefa de #${parentId}${tituloMae ? ` — ${tituloMae}` : ''}. Clique para abrir a ${onAbrir ? 'tarefa' : 'solicitação'} principal.`}
        className={`inline-flex items-center gap-1 max-w-full min-w-0 px-1.5 py-0.5 rounded-md text-[10px] font-bold bg-violet-50 text-violet-700 hover:bg-violet-100 dark:bg-violet-900/30 dark:text-violet-300 dark:hover:bg-violet-900/50 transition-colors ${className}`}
    >
        <CornerDownRight size={10} className="shrink-0" />
        <span className="shrink-0 whitespace-nowrap">Subtarefa de #{parentId}</span>
        {!compacto && tituloMae && <span className="truncate font-semibold opacity-80">· {tituloMae}</span>}
    </button>
);

export default SeloSubtarefa;
